import Carrier from "../Carrier";
import { useAddCarrier } from "../Hooks/useAddCarrier";
import CarrierFormTabs from "./CarrierFormTabs";
import { carrierDefaultValues } from "./carrierDefaultValues";

function AddCarrier() {
  const { mutate: addCarrier } = useAddCarrier();

  return (
    <CarrierFormTabs
      title="Add Carrier"
      carrier={carrierDefaultValues}
      onSave={(carrier: Carrier) => addCarrier(carrier)}
    />
  );
}

export default AddCarrier;
